/**
 * Class names for `Text` components (src/components/Text/).
 */
export const textClassNames = {
  clickToCopyTextRoot: "click-to-copy-text__root",
} as const;
